import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { styled } from '@mui/system';
import { IconButton } from '@mui/material';
import { Edit } from '@mui/icons-material';
import { Tooltip } from '../../atoms/Tooltip';
const StyledListItem = styled(ListItem) `
  padding-top: 0;
  padding-bottom: 0;
  & .MuiListItemText-root{
    margin: 0;
    & > span {
      padding-left: 4px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      font-size: 13px;
    }
  }
`;
;
const StyledListItemIcon = styled(ListItemIcon, {
    shouldForwardProp: prop => prop !== 'isExpanded'
}) `
  height: 24px;
  width: 24px;
  min-width: 62px;
  padding-left: ${({ isExpanded }) => isExpanded ? '12px' : '6px'};
  display: flex;
  align-items: center;
  svg {
    font-size: 18px;
  }
`;
const NavigationDetail = ({ icon, isExpanded, label, onEdit, }) => (_jsxs(StyledListItem, { secondaryAction: isExpanded && onEdit &&
        _jsx(IconButton, { edge: "end", "aria-label": "delete", onClick: onEdit, sx: { margin: 0 }, children: _jsx(Edit, { fontSize: 'small' }) }), children: [isExpanded ? (_jsx(StyledListItemIcon, { isExpanded: isExpanded, children: icon })) : (_jsx(Tooltip, { text: label, placement: "right", children: _jsx(StyledListItemIcon, { isExpanded: isExpanded, children: icon }) })), isExpanded &&
            _jsx(ListItemText, { sx: { fontSize: '13px' }, primary: label })] }));
export default NavigationDetail;
//# sourceMappingURL=NavigationDetail.js.map